(function(){
  if (window.__iopBooted) return; window.__iopBooted = true;

  // ---------- utils
  function tl(n){ return Number(n||0).toLocaleString('tr-TR',{minimumFractionDigits:2, maximumFractionDigits:2}); }

  function getVariantFromURL(){
    try { return new URL(location.href).searchParams.get('variant'); }
    catch(e){ return null; }
  }

  function getVariantFromForm(scope){
    scope = scope || document;
    const sel = scope.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    const checked = scope.querySelector('input[type="radio"][name="id"]:checked');
    if (checked && checked.value) return checked.value;
    const hidden = scope.querySelector('input[type="hidden"][name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }

  function safeJSON(el){
    if (!el) return null;
    try { return JSON.parse(el.textContent || ''); } catch(e){ return null; }
  }

  // "100.049,25 ₺" benzeri metni sayıya çevir
  function parseMoneyStrict(str){
    if (!str) return NaN;
    const cleaned = String(str).replace(/[^\d.,-]/g,'').trim();
    if (!cleaned) return NaN;
    const lastComma = cleaned.lastIndexOf(',');
    const lastDot   = cleaned.lastIndexOf('.');
    if (lastComma === -1 && lastDot === -1) return Number(cleaned);
    const dec  = (lastComma > lastDot) ? ',' : '.';
    const thou = dec === ',' ? '.' : ',';
    return Number(cleaned.replace(new RegExp('\\' + thou, 'g'), '').replace(dec, '.'));
  }

  // sale-price içinden TL'yi oku (.usd-price'ı hariç tut)
  function readTLFromSalePrice(){
    let node = document.querySelector('sale-price.text-lg') || document.querySelector('sale-price') || null;
    if (!node) return NaN;
    const clone = node.cloneNode(true);
    const usd = clone.querySelector('.usd-price'); if (usd) usd.remove();
    return parseMoneyStrict(clone.textContent);
  }

  function renderTables(root, amount, rates){
    const table = root.querySelector('.table-container');
    table.innerHTML = '';
    if (!(amount > 0)) return;

    rates.forEach(opt=>{
      const card = document.createElement('div'); card.className='card-table';

      const header = document.createElement('div'); header.className='card-header';
      const img = document.createElement('img'); img.src = opt.image; img.alt = opt.name + ' Kart';
      const title = document.createElement('div'); title.textContent = opt.name;
      header.appendChild(img); header.appendChild(title); card.appendChild(header);

      const thead = document.createElement('div'); thead.className='table-header';
      thead.innerHTML = '<span>Taksit Tutarı</span><span>Toplam Tutar</span>'; card.appendChild(thead);

      (opt.terms || []).forEach((term,i)=>{
        const adjusted = amount * (opt.rates[i] || 1);
        const per = adjusted / term;
        const row = document.createElement('div'); row.className='row';
        row.innerHTML = `<span>${term} x ${tl(per)} TL</span><span>${tl(adjusted)} TL</span>`;
        card.appendChild(row);
      });

      table.appendChild(card);
    });
  }

  function mountOne(root){
    if (!root || root.__mounted) return; root.__mounted = true;

    const variants = safeJSON(root.querySelector('script[data-iop-variants]')) || [];
    const rates    = safeJSON(root.querySelector('script[data-iop-rates]'))    || [];
    const initialVariantId = root.getAttribute('data-initial-variant');
    const initialAmount    = Number(root.getAttribute('data-initial-amount') || 0);

    const productScope =
      root.closest('section, .shopify-section, form[action*="/cart/add"], .product, .product-page') || document;

    function activeVariant(){
      let vid = getVariantFromForm(productScope) || getVariantFromURL() || initialVariantId;
      let v = null;
      if (vid) v = variants.find(x => String(x.id) === String(vid));
      if (!v)  v = variants.find(x => x.available) || variants[0] || null;
      return v;
    }

    // 1) Varyant JSON’dan fiyat (en güvenlisi)
    function refreshFromVariantJSON(){
      const v = activeVariant();
      if (v && (v.price || v.price === 0)){
        const cents = typeof v.price === 'number' ? v.price : Number(v.price || 0);
        if (cents > 0) { renderTables(root, cents/100, rates); return true; }
      }
      return false;
    }

    // 2) DOM’daki sale-price’tan fiyat (tema re-render ediyorsa)
    function refreshFromSalePriceDOM(){
      const tlAmount = readTLFromSalePrice();
      if (tlAmount > 0){
        renderTables(root, tlAmount, rates);
        return true;
      }
      return false;
    }

    // Tek bir refresh: önce JSON, olmazsa DOM
    function refresh(){
      if (refreshFromVariantJSON()) return;
      if (refreshFromSalePriceDOM()) return;
      if (initialAmount > 0) renderTables(root, initialAmount, rates);
    }

    // --- Tetikleyiciler ---

    // 1) Varyant kontrol değişimleri (select/radio/hidden)
    productScope.addEventListener('change', function(e){
      const t = e.target;
      if (!t) return;
      if (t.name === 'id' || (t.matches && t.matches('[name="id"]'))){
        requestAnimationFrame(refresh);
      }
    });

    // 2) Yaygın tema event’leri
    ['variant:changed','product:variant-change','product:variantChanged','theme:variant:change','variantChange','shopify:variant:change']
      .forEach(evt => document.addEventListener(evt, refresh));

    // 3) URL değişimi (tema pushState ile ?variant= değiştirirse)
    window.addEventListener('popstate', refresh);

    // 4) USD kodundaki yaklaşımla: body’ye eklenen yeni sale-price/price düğümlerini yakala
    const mo = new MutationObserver(muts=>{
      let touched = false;
      muts.forEach(m => {
        m.addedNodes && m.addedNodes.forEach(node=>{
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('sale-price, compare-at-price')) touched = true;
          if (!touched) {
            const sp = node.querySelector && node.querySelector('sale-price, compare-at-price');
            if (sp) touched = true;
          }
        });
      });
      if (touched) refreshFromSalePriceDOM();
    });
    mo.observe(document.body, { childList:true, subtree:true });

    // İlk çizim
    refresh();
  }

  function mountAll(){
    document.querySelectorAll('.installment-calculator').forEach(mountOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  // Shopify editor/dinamik section’lar
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:select', mountAll);
})();
